import { render, staticRenderFns } from "./PracticeUsers.vue?vue&type=template&id=36a81dbd&"
import script from "./PracticeUsers.vue?vue&type=script&lang=js&"
export * from "./PracticeUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports